import { WizardMode } from "../../../../wizard/types";
import { SCHOOL_GRADE } from "../../../constants";
import { separateRequiredDocs } from "../../helpers/helperFunctions";

export function parseToFrontEndModel(backendModel, mode) {
  const frontendModel = {};

  backendModel.forEach((schoolLevel) => {
    if (
      mode === WizardMode.Create &&
      (!schoolLevel.academics.length || schoolLevel.id === "_3")
    ) {
      frontendModel[schoolLevel.id] = {
        additionalDocuments: {},
        applicationForms: [],
        requiredDocs: [],
      };
    } else {
      const { requiredDocuments, additionalDocuments } = separateRequiredDocs(
        schoolLevel.academics[0].requiredDocs,
      );

      frontendModel[schoolLevel.id] = {
        additionalDocuments: additionalDocuments,
        requiredDocs: requiredDocuments,
      };

      frontendModel[schoolLevel.id].schoolType = {
        id: schoolLevel.academics[0].schoolType,
        name: schoolLevel.academics[0].schoolTypeName,
      };

      if (schoolLevel.id === "_3") {
        const backEndGrade = schoolLevel.academics[0].grade;
        const frontEndGrade = SCHOOL_GRADE.find((g) => g.name === backEndGrade);

        if (frontEndGrade) {
          frontendModel[schoolLevel.id].schoolGrade = frontEndGrade;
        } else {
          frontendModel[schoolLevel.id].otherGrade = backEndGrade;
        }
      }

      if (schoolLevel.academics[0].applicationForms) {
        frontendModel[schoolLevel.id].applicationForms =
          schoolLevel.academics[0].applicationForms.map((af) => ({
            id: af.fileId,
            name: af.name,
            size: af.size,
            path: af.path,
          }));
      }

      if (schoolLevel.academics[0].applicationLink) {
        frontendModel[schoolLevel.id].applicationLink =
          schoolLevel.academics[0].applicationLink;
      }
    }
  });

  return frontendModel;
}
